import Highway from '@dogstudio/highway/src/highway'
import LocomotiveScroll from 'locomotive-scroll'
import lottie from 'lottie-web'
import SplitTextJS from 'split-text-js'

import { throttle } from 'underscore'

import MotionTime from './modules/MotionTime'

import ContactIcon from './modules/ContactIcon'
import DevilInsideOfMe from './modules/DevilInsideOfMe'

import gsap from 'gsap'

import '../scss/_About.scss'

import animBlockBrandIdentity from '../anims/about/brandidentity.json'
import animBlockPrint from '../anims/about/printdesign.json'
import animBlockIllustration from '../anims/about/illustrationdrawing.json'
import animBlockPug from '../anims/about/pugpetting.json'

export default class About extends Highway.Renderer {
    onEnter() {
        window.scrollTo(0, 0)
        this.motionTime = new MotionTime()
        this.timelines = []
        this.prepareAnimations()
    }

    onEnterCompleted() {
        this.scroll = new LocomotiveScroll({
            smooth: true,
            smoothMobile: true,
            el: document.querySelector('[data-scroll-container]'),
            inertia: 0.75,
            offset: ['35%', 0],
        })

        this.mouseCoords = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        }

        setTimeout(() => {
            this.scroll.update()
        }, 400)

        // Separators
        const allBlocksSeparators = document.querySelectorAll('.separator')
        const blockSeparatorsObs = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active')
                    }
                })
            },
            {
                root: document.querySelector('null'),
                rootMargin: '-300px',
                treshold: [0, 1],
            }
        )

        allBlocksSeparators.forEach((separator) => {
            blockSeparatorsObs.observe(separator)
        })

        // Init lottie animations
        const animBrandIdentity = lottie.loadAnimation({
            path: animBlockBrandIdentity,
            loop: true,
            autoplay: false,
            renderer: 'svg',
            container: document.querySelector(
                '.skill:first-of-type .skill__animation'
            ),
            rendererSettings: {},
        })

        const animIllustration = lottie.loadAnimation({
            path: animBlockIllustration,
            loop: true,
            autoplay: false,
            renderer: 'svg',
            container: document.querySelector(
                '.skill:nth-of-type(2) .skill__animation'
            ),
        })

        const animPrint = lottie.loadAnimation({
            path: animBlockPrint,
            loop: true,
            autoplay: false,
            renderer: 'svg',
            container: document.querySelector(
                '.skill:nth-of-type(3) .skill__animation'
            ),
        })

        const animPugContainer = document.querySelector(
            '.skill:nth-of-type(4) .skill__animation'
        )

        const animPug = lottie.loadAnimation({
            path: animBlockPug,
            loop: false,
            autoplay: false,
            renderer: 'svg',
            container: animPugContainer,
        })

        const pugBeforeUnlockLoop = () => {
            if (animPug.currentRawFrame > 80) {
                animPug.goToAndPlay(0, true)
            }
        }

        const pugAfterUnlockLoop = () => {
            if (animPug.currentRawFrame > 248) {
                setTimeout(() => {
                    animPug.goToAndPlay(134, true)
                }, 2500)
            }
        }

        animPug.addEventListener('enterFrame', pugBeforeUnlockLoop)

        animPugContainer.addEventListener('click', () => {
            animPug.removeEventListener('enterFrame', pugBeforeUnlockLoop)
            animPug.addEventListener('enterFrame', pugAfterUnlockLoop)
            // animPug.setSpeed(1.5);
            this.motionTime.unlockItem(9)
        })

        this.devilInsideOfMeInstance = new DevilInsideOfMe()

        const contactIconInstance = new ContactIcon(
            'locomotive-scroll',
            this.scroll
        )

        // Setting up lottie animations to be played only when in view
        this.scroll.on('call', (func, state) => {
            switch (func) {
                case 'introduction':
                    if (state == 'enter') {
                        this.timelines['introduction'].play()
                    }
                    break

                case 'skill-0':
                    if (state == 'enter') {
                        animBrandIdentity.play()
                        this.timelines['skill_0'].play()
                    } else {
                        animBrandIdentity.pause()
                    }
                    break

                case 'skill-1':
                    if (state == 'enter') {
                        animIllustration.play()
                        this.timelines['skill_1'].play()
                    } else {
                        animIllustration.pause()
                    }
                    break

                case 'skill-2':
                    if (state == 'enter') {
                        animPrint.play()
                        this.timelines['skill_2'].play()
                    } else {
                        animPrint.pause()
                    }
                    break

                case 'skill-3':
                    if (state == 'enter') {
                        const motionTimeStorage = this.motionTime.getStorage()
                        if (motionTimeStorage.achievements[9] == 'unlocked') {
                            animPug.removeEventListener(
                                'enterFrame',
                                pugBeforeUnlockLoop
                            )
                            animPug.addEventListener(
                                'enterFrame',
                                pugAfterUnlockLoop
                            )
                            animPug.goToAndPlay(134, true)
                        } else {
                            animPug.removeEventListener(
                                'enterFrame',
                                pugAfterUnlockLoop
                            )
                            animPug.addEventListener(
                                'enterFrame',
                                pugBeforeUnlockLoop
                            )
                            animPug.goToAndPlay(0, true)
                        }
                        animPug.play()
                        this.timelines['skill_3'].play()
                    } else {
                        const motionTimeStorage = this.motionTime.getStorage()
                        animPug.pause()

                        // if (motionTimeStorage.achievements[9] == 'unlocked') {
                        //     animPug.goToAndStop(134);
                        // } else {
                        //     animPug.goToAndStop(0);
                        // }
                    }
                    break

                case 'clients':
                    if (state == 'enter') {
                        this.timelines['clients'].play()
                    }
                    break
            }
        })

        // scroll header fix
        const header = document.querySelector('.header')

        this.scroll.on('scroll', (e) => {
            const currentScroll = e.scroll.y
            currentScroll > 10
                ? header.classList.add('smaller')
                : header.classList.remove('smaller')
        })
    }

    onLeave() {
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 200)
        this.devilInsideOfMeInstance.destroyAll()
        this.scroll.destroy()
    }

    prepareAnimations() {
        // Introduction
        const blockIntroduction = document.querySelector(
            '.section__introduction'
        )
        const blockIntroductionPicture = blockIntroduction.querySelector(
            '.introduction__picture'
        )
        const blockIntroductionTitle = blockIntroduction.querySelector(
            '.block__title'
        )
        const blockIntroductionContent = blockIntroduction.querySelector(
            '.block__description'
        )
        // const blockSeparator = blockIntroductionContent.querySelector('.block__separator');

        let introductionTl = new gsap.timeline({
            paused: true,
        })

        introductionTl.add(
            gsap.fromTo(
                blockIntroductionPicture,
                {
                    opacity: 0,
                    y: 200,
                },
                {
                    duration: 1,
                    y: 0,
                    opacity: 1,
                    ease: 'expo.easeOut',
                }
            ),
            0
        )

        introductionTl.add(
            gsap.fromTo(
                blockIntroductionTitle,
                {
                    opacity: 0,
                    y: 40,
                },
                {
                    duration: 0.4,
                    y: 0,
                    opacity: 1,
                    ease: 'expo.easeOut',
                }
            ),
            0.1
        )

        introductionTl.add(
            gsap.fromTo(
                blockIntroductionContent,
                {
                    opacity: 0,
                    y: 40,
                },
                {
                    duration: 0.4,
                    y: 0,
                    opacity: 1,
                    ease: 'expo.easeOut',
                }
            ),
            0.2
        )

        // introductionTl.add(gsap.fromTo(blockSeparator, {
        //     scaleY: 0
        // }, {
        //     scaleY: 1,
        //     duration: 1,
        //     ease: 'expo.easeInOut'
        // }), 0.8);

        this.timelines['introduction'] = introductionTl

        // Skills
        const allSkills = document.querySelectorAll('.section__skills .skill')

        allSkills.forEach((skill, index) => {
            const skillNumber = skill.querySelector('.skill__number')
            const skillTitle = skill.querySelector('.skill__title')
            const skillIcon = skill.querySelector('.skill__animation')
            const skillDescription = skill.querySelector('.skill__description')
            // const skillSeparator = skillDescription.querySelector('.skill__separator');

            const indexName = 'skill_' + index

            let skillTl = new gsap.timeline({
                paused: true,
            })

            if (skillNumber) {
                const skillNumberSplit = new SplitTextJS(skillNumber)

                skillTl.add(
                    gsap.fromTo(
                        skillNumberSplit.chars,
                        {
                            x: 10,
                            opacity: 0,
                        },
                        {
                            x: 0,
                            opacity: 1,
                            stagger: 0.1,
                            duration: 0.4,
                            ease: 'expo.easeOut',
                        }
                    ),
                    0
                )
            }

            if (skillIcon) {
                skillTl.add(
                    gsap.fromTo(
                        skillIcon,
                        {
                            opacity: 0,
                        },
                        {
                            opacity: 1,
                            duration: 0.4,
                            ease: 'expo.easeOut',
                        }
                    ),
                    0
                )
            }

            if (skillTitle) {
                skillTl.add(
                    gsap.fromTo(
                        skillTitle,
                        {
                            x: 40,
                            opacity: 0,
                        },
                        {
                            x: 0,
                            opacity: 1,
                            ease: 'expo.easeOut',
                            duration: 0.4,
                        }
                    ),
                    0.1
                )
            }

            skillTl.add(
                gsap.fromTo(
                    skillDescription,
                    {
                        opacity: 0,
                        y: 40,
                    },
                    {
                        y: 0,
                        opacity: 1,
                        ease: 'expo.easeOut',
                        duration: 0.4,
                    }
                ),
                0.2
            )

            // skillTl.add(gsap.fromTo(skillSeparator, {
            //     scaleY: 0
            // }, {
            //     scaleY: 1,
            //     duration: 1,
            //     ease: 'expo.easeInOut',
            //     onComplete: () => {
            //         // gsap.to(skillSeparator, {
            //         //     duration: 1,
            //         //     height: 0,
            //         //     ease: 'expo.easeOut',
            //         //     transformOrigin: '50% 100%'
            //         // });
            //     }
            // }), 0.8);

            this.timelines[indexName] = skillTl
        })

        // Clients

        const blockClients = document.querySelector('.section__clients')
        const blockClientsTitle = blockClients.querySelector('.block__title')
        const blockClientsItems = blockClients.querySelectorAll(
            '.clients__grid .client'
        )
        const blockClientsLink = blockClients.querySelector('.clients__link')
        const blockClientsLinkText = blockClientsLink.querySelector('span')
        const blockClientsLinkArrow = blockClientsLink.querySelector('svg')

        let clientsTl = new gsap.timeline({
            paused: true,
        })

        if (blockClientsTitle) {
            clientsTl.add(
                gsap.fromTo(
                    blockClientsTitle,
                    {
                        x: 40,
                        opacity: 0,
                    },
                    {
                        duration: 0.4,
                        ease: 'expo.easeOut',
                        x: 0,
                        opacity: 1,
                    }
                ),
                0
            )
        }

        if (blockClientsItems) {
            clientsTl.add(
                gsap.fromTo(
                    blockClientsItems,
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        ease: 'expo.easeOut',
                        duration: 1,
                        stagger: 0.1,
                    }
                ),
                0
            )
        }

        if (blockClientsLink) {
            const blockClientsLinkTextSplit = new SplitTextJS(
                blockClientsLinkText
            )

            clientsTl.add(
                gsap.fromTo(
                    blockClientsLinkTextSplit.chars,
                    {
                        opacity: 0,
                        x: 5,
                    },
                    {
                        x: 0,
                        opacity: 1,
                        ease: 'expo.easeOut',
                        duration: 0.2,
                        stagger: 0.05,
                    }
                ),
                '-=0.4'
            )

            clientsTl.add(
                gsap.fromTo(
                    blockClientsLinkArrow,
                    {
                        x: -40,
                        opacity: 0,
                    },
                    {
                        x: 0,
                        opacity: 1,
                        ease: 'expo.easeOut',
                        duration: 0.2,
                    }
                ),
                '-=0.2'
            )
        }

        this.timelines['clients'] = clientsTl
    }
}
